module.exports = __webpack_public_path__ + "media/assets/good_at/angular-abe08b4bb62f895f11e57d2b76fe0ec1.png";